import { useMatch } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { $boardError } from '../../GRID/model/board';
import { $isDeskDontAccess } from '../../GRID/model/card';

export function useIsRightMenu() {
  const isDesk = useMatch('d/*');
  const isTask = useMatch('c/*');
  const [boardError,isDeskDontAccess] = useUnit([$boardError,$isDeskDontAccess]);
  if(boardError) return false
  if(isDeskDontAccess) return false

  return isDesk || isTask;
}
